import React, { memo, useState } from 'react';
import { Row, Col, Button, DatePicker, Input, Select, message } from 'antd';
const { Option } = Select;
// import moment from 'moment';
import { getBase64 } from '../utils/assetUtils';
import {
  preSignedUrlReplica,
  uploadFileToS3Replica
} from '../actions/sessionActions';
import { postReleaseNotes } from '../actions/sessionActions';

const ReleaseNotes = () => {
  // const { RangePicker } = DatePicker;
  const { TextArea } = Input;
  // const
  const contentType = [
    { label: 'All', value: 'ALL' },
    { label: 'Feature', value: 'FEATURE' },
    { label: 'Announcement', value: 'ANNOUNCEMENTS' },
    { label: 'Beta', value: 'BETA' },
    { label: 'Improvement', value: 'IMPROVEMENT' },
    { label: 'Blog', value: 'BLOG' },
    { label: 'Archived', value: 'ARCHIVED' }
  ];
  const [state, setState] = useState({
    contentType: null,
    title: null,
    image: null,
    description: null,
    externalLink: null,
    publishedDate: null
  });

  // below code is commented for future development
  // const dateChange = (date, dateString, name, i) => {
  //   const { formInput } = this.setState;
  //   formInput.[name] = dateString;
  //   this.setState({ formInput }, this.validate());
  // }

  const onSelectChange = (value, key) => {
    setState({
      ...state,
      [key]: value
    });
  };

  const reset = () => {
    setState({
      ...state,
      contentType: null,
      title: null,
      image: null,
      description: null,
      externalLink: null,
      publishedDate: null
    });
  };

  const submit = () => {
    let preUrl = `${'bannerImage' + parseInt(new Date().getTime() / 1000)}_${
      state.contentType
    }_${state.title}_${state.image.name}`;
    getBase64(state.image, () => {
      preSignedUrlReplica(preUrl).then(res => {
        if (res) {
          const { url, fields } = res;
          uploadFileToS3Replica({ file: state.image, url, fields }).then(() => {
            const payload = {
              contentType: state.contentType,
              title: state.title,
              image: 'https://pyck-res-bucket.s3.amazonaws.com/' + preUrl,
              description: state.description,
              externalLink: state.externalLink
            };
            postReleaseNotes([payload]).then(result => {
              if (result.meta.status === 200) {
                reset();
                message.success('Release note has been published');
              } else {
                message.error(`${result.meta.message}`);
              }
            });
          });
        }
      });
    });
  };

  return (
    <div>
      <h2>Configure Release Notes</h2>
      <Row className="margin-bottom-10">
        <Col span={3}>
          <span>Published Date:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <DatePicker
            className="width-100"
            value={state.publishedDate}
            onChange={value => onSelectChange(value, 'publishedDate')}
          />
        </Col>

        <Col span={3}>
          <span>Content Type :</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Select
            name="contentType"
            id="contentType"
            showSearch
            style={{ width: '100%' }}
            placeholder="Select Content Type"
            optionFilterProp="children"
            value={state.contentType}
            onChange={value => onSelectChange(value, 'contentType')}
            filterOption={(input, option) =>
              option.props.children.towerCase().indexOf(input.toLowerCase()) >=
              0
            }
          >
            {contentType.map((type, i) => (
              <Option key={i} value={type.value}>
                {type.label}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={3}>
          <span>Title:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Input
            name="title"
            placeholder={`title`}
            className="ant-input"
            value={state.title}
            onChange={value => onSelectChange(value.target.value, 'title')}
          />
        </Col>

        <Col span={3}>
          <span>Banner Image:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          {/* <Input
            name="image"
            placeholder={`image`}
            className="ant-input"
            value={state.image}
            onChange={value => onSelectChange(value.target.value, 'image')}
          /> */}
        </Col>
        <Col span={21} className="margin-bottom-10">
          <input
            type="file"
            name="image"
            onChange={value => onSelectChange(value.target.files[0], 'image')}
          />
        </Col>

        <Col span={3}>
          <span>Description:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <TextArea
            rows={4}
            name="Description"
            minLength={300}
            placeholder="Enter description"
            value={state.description}
            onChange={value =>
              onSelectChange(value.target.value, 'description')
            }
          />
        </Col>
        <Col span={3}>
          <span>External Link:</span>
        </Col>
        <Col span={21} className="margin-bottom-10">
          <Input
            name="externalLink"
            placeholder={`External Link`}
            className="ant-input"
            value={state.externalLink}
            onChange={value =>
              onSelectChange(value.target.value, 'externalLink')
            }
          />
        </Col>

        <Col span={24} className="margin-bottom-20  margin-top-20 text-center">
          <Button type="primary" onClick={submit}>
            Submit
          </Button>
          <Button className="margin-lr-8" onClick={reset}>
            Reset
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default memo(ReleaseNotes);
